import {ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'vw-loader',
    imports: [],
    templateUrl: './loader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnChanges {


    constructor(public zone: NgZone, private ref: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.calculate();
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    calculate() {
    }
}
